// 后台曾与公开站同源（yepsavings.com/ecom/），公开站上的第三方脚本（Ezoic、CMP、GTM…）
// 能写一个与后台同名的 cookie 把真 token 遮蔽掉，且后台删不掉它。迁到独立子域之后改用
// __Host- 前缀，让浏览器直接拒绝那种写法：带 domain 属性的 __Host- cookie 会被整条丢弃，
// 不带 domain 的则是 yepsavings.com 的 host-only cookie、永远送不到子域。
const HOST_PREFIXED_NAME = '__Host-loginToken'

// 只在写不进 __Host- 的环境用（真机调 /m/ 页面时走 LAN IP，不是可信来源）。
// 故意不复用旧名字 'loginToken'：这样"新代码永远不读 loginToken"是一条无条件的、
// 可 grep 可单测的不变量，而不是一条需要每次重新推导"那个分支 prod 会不会走到"的条件性结论。
const FALLBACK_NAME = 'dev-loginToken'

const PROD_DOMAIN = 'yepsavings.com'
const TRUSTWORTHY_HOSTS = ['localhost', '127.0.0.1', '[::1]']

// __Host- 的三个硬要求：带 Secure、Path=/、不带 Domain。缺一条浏览器就整条丢弃。
// 删除动作发出的同样是一条 Set-Cookie，也要满足这三条 —— 所以写和删必须用同一份属性。
function hostPrefixedCookie() {
  return {
    name: HOST_PREFIXED_NAME,
    options: { path: '/', secure: true, sameSite: 'strict' }
  }
}

function fallbackCookie() {
  return {
    name: FALLBACK_NAME,
    options: { path: '/', sameSite: 'strict' }
  }
}

function isProdHost(hostname) {
  return hostname === PROD_DOMAIN || hostname.slice(-(PROD_DOMAIN.length + 1)) === '.' + PROD_DOMAIN
}

// 判的是「本文档自己的 URL 可不可信」。不要换成 window.isSecureContext —— 那个还要求
// 所有祖先浏览上下文都可信，被不可信页面 iframe 嵌进去时是 false，而那种情况下
// __Host- cookie 其实写得进去，按它分支会白白降级到一个没有前缀保护的名字。
function isTrustworthyDocument(protocol, hostname) {
  return protocol === 'https:' || TRUSTWORTHY_HOSTS.indexOf(hostname) !== -1
}

function resolveTokenCookie(protocol, hostname) {
  const proto = String(protocol || '')
  const host = String(hostname || '')

  // fail-closed：生产域名下无条件用 __Host-。HSTS preload 保证这里 protocol 必然是
  // https，所以这条与下面那条重合；它存在的意义是万一判据出别的岔子，prod 宁可写不进
  // cookie（setToken 的回读断言会报出来），也不要静默降级。
  // 主机匹配写宽了无害：误判进 __Host- 分支是安全的那一侧。
  if (isProdHost(host)) return hostPrefixedCookie()

  return isTrustworthyDocument(proto, host) ? hostPrefixedCookie() : fallbackCookie()
}

module.exports = { resolveTokenCookie }
